import { getCookie } from '@frontend/common';
import { FunctionalityClient } from '@frontend/functionality/api';
import { Functionality } from '@frontend/functionality/types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { recursiveFetch } from './utils';

const TELLOPORT_SELECTED_ACCOUNT_COOKIE = 'tp_prev_sel_acc';

async function getLicenseInfo(account_id: string) {
    const functionalities = await recursiveFetch<Functionality>(async (arg) => {
        return await FunctionalityClient.fetchFunctionalities({ ...arg, account_id });
    });

    return { functionalities };
}

export function useApplicationFunctionalities(): Functionality[] {
    const account_id = getCookie(TELLOPORT_SELECTED_ACCOUNT_COOKIE) ?? null;
    const { pathname } = useLocation();
    const [functionalities, setFunctionalities] = useState<Functionality[]>([]);

    useEffect(() => {
        if (pathname.includes('/standalone') || !account_id) {
            setFunctionalities([]);
            return;
        }

        getLicenseInfo(account_id).then(({ functionalities: loaded }) => {
            setFunctionalities(loaded);
        });
    }, [account_id, pathname]);

    return functionalities;
}
